import moment from "moment";
const enabled = (value) => [true, 1, "1"].includes(value);
export function userDetailDate(value, dateOnly = false) {
  const date = moment(value, dateOnly ? "YYYY-MM-DD" : moment.ISO_8601, true);
  return value && date.isValid()
    ? dateOnly
      ? date.format("YYYY-MM-DD")
      : date.utcOffset(480).format("YYYY-MM-DD HH:mm:ss")
    : "-";
}
export function userDetailsModel(data = {}) {
  const name =
    data.full_name ||
    data.name ||
    [data.first_name, data.last_name].filter(Boolean).join(" ") ||
    data.email ||
    "-";
  return {
    uuid: data.uuid,
    name,
    firstName: data.first_name || "-",
    lastName: data.last_name || "-",
    email: data.email || "-",
    image: data.image || "",
    initials: name
      .split(/\s+/)
      .slice(0, 2)
      .map((word) => word[0])
      .join("")
      .toUpperCase(),
    birthDate: userDetailDate(data.birth_date, true),
    phone: data.phone
      ? [data.phone_code, data.phone].filter(Boolean).join(" ")
      : "-",
    phoneIso: data.phone_iso || "-",
    employeeId: data.iwowsoft_employee_uuid || "-",
    userType: data.user_type ?? "-",
    role: data.role?.name || "-",
    isActive: enabled(data.is_active),
    isSuperadmin: enabled(data.is_superadmin),
    isOrientation: enabled(data.is_orientation),
    emailVerifiedAt: userDetailDate(data.email_verified_at),
    phoneVerifiedAt: userDetailDate(data.phone_verified_at),
    appAccess: data.app_access == null ? null : Number(data.app_access),
    portalAccess:
      data.portal_access == null ? null : Number(data.portal_access),
    appLastLogin: userDetailDate(data.app_last_login_at),
    portalLastLogin: userDetailDate(data.portal_last_login_at),
    appAttempts: data.app_login_attempt ?? 0,
    portalAttempts: data.portal_login_attempt ?? 0,
    permissions: data.permission ?? data.permissions ?? {},
    companies: (Array.isArray(data.user_companies) ? data.user_companies : [])
      .map((item) => ({
        uuid: item.uuid,
        sequence: item.sequence ?? "-",
        companyUUID: item.company?.uuid || null,
        company: item.company?.display_name || item.company?.name || "-",
        department: item.department?.name || "-",
        office: item.office?.name || "-",
        position: item.position?.name || "-",
      }))
      .sort((a, b) => (Number(a.sequence) || 0) - (Number(b.sequence) || 0)),
    createdAt: userDetailDate(data.created_at),
    createdBy: data.created_by || "-",
    updatedAt: userDetailDate(data.updated_at),
    updatedBy: data.updated_by || "-",
  };
}
export function userDetailPermissions(user, definitions = []) {
  const modules = new Map(definitions.map((module) => [module.key, module]));
  const reserved = [
    "uuid",
    "id",
    "created_at",
    "created_by",
    "updated_at",
    "updated_by",
    "deleted_at",
    "deleted_by",
  ];
  Object.entries(user.permissions || {}).forEach(([key, value]) => {
    if (
      !reserved.includes(key) &&
      /^[a-z][a-z0-9_]*$/.test(key) &&
      [0, 1, 2, "0", "1", "2"].includes(value) &&
      !modules.has(key)
    )
      modules.set(key, {
        key,
        name: key
          .replace(/_/g, " ")
          .replace(/\b\w/g, (letter) => letter.toUpperCase()),
        options: [],
      });
  });
  return [...modules.values()].map((module) => {
    const stored = user.permissions[module.key];
    const level = user.isSuperadmin
      ? 2
      : [0, 1, 2, "0", "1", "2"].includes(stored)
      ? Number(stored)
      : 0;
    return {
      key: module.key,
      name: module.name,
      level,
      definition:
        module.options.find((option) => option.value === level)?.text || "",
    };
  });
}
